import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import MarketingLayout from "../../marketing/components/MarketingLayout";

const ForgotPassword = () => {
  const { forgotPassword } = useAuth();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");
    try {
      const res = await forgotPassword(email.trim());
      setMessage(
        res?.message ||
          "Si un compte existe pour cet email, un lien de réinitialisation a été envoyé."
      );
    } catch (err) {
      console.error(err);
      // Always show generic message to avoid user enumeration
      setMessage(
        "Si un compte existe pour cet email, un lien de réinitialisation a été envoyé."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <MarketingLayout showFinalCta={false} variant="auth">
      <Helmet>
        <title>Mot de passe oublié - ASAP Hub</title>
        <meta name="description" content="Réinitialisez votre mot de passe ASAP Hub. Un lien de réinitialisation vous sera envoyé par email." />
      </Helmet>

      <section className="mk-contact-section" data-testid="forgot-password-page">
        <div className="mk-wrap mk-contact-grid">
          <aside className="mk-reveal">
            <span className="mk-eyebrow">
              <span className="mk-pulse" aria-hidden="true" />
              Récupération de compte
            </span>
            <h1>Mot de passe oublié&nbsp;?</h1>
            <p className="mk-lead">
              Saisissez l'adresse email associée à votre compte ASAP Hub. Si elle existe, nous vous enverrons un lien sécurisé pour définir un nouveau mot de passe.
            </p>
            <div className="mk-info-list">
              <div className="mk-info-item">
                <i aria-hidden="true">⏱</i>
                <div><b>Email immédiat</b>Le lien arrive en quelques secondes</div>
              </div>
              <div className="mk-info-item">
                <i aria-hidden="true">✓</i>
                <div><b>Lien sécurisé</b>Valide une heure, à usage unique</div>
              </div>
            </div>
          </aside>

          <div className="mk-contact-card mk-reveal">
            <form onSubmit={handleSubmit} noValidate>
              <h3>Réinitialiser votre mot de passe</h3>

              {message && (
                <div className="mk-form-info" role="status" data-testid="forgot-success">{message}</div>
              )}

              <div className="mk-field">
                <label htmlFor="email">Votre email <span className="mk-required">*</span></label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                  autoComplete="email"
                  required
                />
              </div>

              <button
                type="submit"
                className="mk-btn mk-btn-primary"
                disabled={isSubmitting}
                style={{ width: "100%", padding: "14px 18px" }}
                data-testid="forgot-submit"
              >
                {isSubmitting ? "Envoi en cours…" : "Envoyer le lien"}
              </button>

              <p className="mk-auth-help">
                Vous vous souvenez de votre mot de passe ? <Link to="/login">Se connecter</Link>
              </p>
            </form>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
};

export default ForgotPassword;
